import { render, staticRenderFns } from "./LinkDetails.vue?vue&type=template&id=94e1c15a&scoped=true"
import script from "./LinkDetails.vue?vue&type=script&lang=js"
export * from "./LinkDetails.vue?vue&type=script&lang=js"
import style0 from "./LinkDetails.vue?vue&type=style&index=0&id=94e1c15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e1c15a",
  null
  
)

export default component.exports